import { Component, Input } from '@angular/core';

import { Rodeo } from "../../model/rodeo";

@Component({
    selector: 'rodeo-information',
    templateUrl: 'rodeo-information.html'
})
export class RodeoInformation {
    _rodeo: Rodeo;
    _showRegistration: boolean;

    @Input()
    set rodeo(rodeo: Rodeo) {
        if (rodeo != null) {
            this._rodeo = rodeo;
        }
    }
    get rodeo(): Rodeo {
        return this._rodeo;
    }

    @Input()
    set showRegistration(show: boolean) {
        if (show != null) {
            this._showRegistration = show;
        }
    }
    get showRegistration(): boolean {
        return this._showRegistration;
    }

    constructor() { }
}


// WEBPACK FOOTER //
// ./src/pages/rodeo/rodeo-information.ts